import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function MultiSelectSearch({
  label,
  onChange,
  options,
  variant,
}) {
  return (
    <Autocomplete
      multiple
      limitTags={4}
      size="small"
      fullWidth={true}
      id={"multi-select-search " + label}
      options={options}
      getOptionLabel={(option) => option}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant ?? "standard"}
          label={label}
          placeholder={label}
        />
      )}
    />
  );
}
